import { Link } from "react-router";
import type { Task } from "../../api/hub/types";
import { safeReference } from "../tasks/TaskMeta";

// 只折叠正文中的技术编号。URL 作为一个完整来源保留，不处理其中的编号。
const UUID = /\b[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}\b/gi;
const SOURCE_URL =
  /(https?:\/\/[^\s<>"')\]}，。；]+|\/(?:tasks|projects|project-agents|approvals|decisions|kb|inspiration)(?:[/?#][^\s<>"')\]}，。；]*)?)/g;

export function DecisionEvidence({
  value,
  responsibilityId,
  sourceUrl,
  task,
}: {
  value: string;
  responsibilityId?: string;
  sourceUrl?: string;
  task?: Pick<Task, "id" | "identifier">;
}) {
  const parts = value.split(SOURCE_URL);
  const sourceLinks = parts.filter((part) => safeReference(part));
  const hasTechnicalIds = parts.some(
    (part) => !safeReference(part) && part.match(UUID),
  );
  const responsibilityUrl = responsibilityId
    ? `/project-agents/${encodeURIComponent(responsibilityId)}`
    : undefined;
  return (
    <div className="decision-evidence">
      <p>
        <b>依据</b>{" "}
        {parts.map((part, i) =>
          safeReference(part) ? (
            <a key={i} href={part} target="_blank" rel="noreferrer">
              查看依据
            </a>
          ) : (
            <span key={i}>{part.replace(UUID, "（技术编号见明细）")}</span>
          ),
        )}
        {responsibilityUrl && !sourceLinks.includes(responsibilityUrl) && (
          <>
            {" · "}
            <Link to={responsibilityUrl}>项目职责来源</Link>
          </>
        )}
        {sourceUrl &&
          safeReference(sourceUrl) &&
          !sourceLinks.includes(sourceUrl) &&
          sourceUrl !== responsibilityUrl && (
            <>
              {" · "}
              <a href={sourceUrl} target="_blank" rel="noreferrer">
                查看来源
              </a>
            </>
          )}
        {task && (
          <>
            {" · "}
            <Link to={`/tasks?task=${encodeURIComponent(task.id)}`}>
              {task.identifier}
            </Link>
          </>
        )}
      </p>
      {hasTechnicalIds && (
        <details className="decision-evidence-details">
          <summary>核对明细</summary>
          <pre>{value}</pre>
        </details>
      )}
    </div>
  );
}
